import { LabelModel } from "@projectstorm/react-diagrams";

export default class ComponentLinkLabelModel extends LabelModel {
  constructor(options) {
    super({
      ...options,
      type: "component-link-label",
    });
    // this.value = options.value || "";
  }

  // serialize() {
  //   return {
  //     ...super.serialize(),
  //     value: this.value,
  //   };
  // }

  // deserialize(event) {
  //   super.deserialize(event);
  //   this.value = event.data.value;
  // }
}
